import {css} from 'emotion'
import {Colors, Link} from './..'
import { Easings } from '../core';

export const NewsStyle = css({
  '.spotlight': {
    '&-title': {
      textTransform: 'uppercase',
      fontSize: '1.125rem',
    },
    '&-news': {
      '.news-info': {
        maxWidth: '100%',
        flexBasis: '100%',
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(100% - 160px)',
          flexBasis: 'calc(100% - 160px)',
        },
      },
      '.news-link': {
        display: 'block',
        height: 60,
        lineHeight: '60px',
        textAlign: 'left',
        '@media (min-width: 1024px)': {
          textAlign: 'center',
          height: 80,
          lineHeight: '80px',
        },
      },
      '.news-picture': {
        position: 'relative',
        height: 260,
        '@media (min-width: 1024px)': {
          height: 540,
        }
      },
      '.news-button': {
        justifyContent: 'flex-end',
      },
      '.news-right': {
        width: '100%',
        display: 'flex',
        '@media (min-width: 1024px)': {
          width: 160,
          display: 'block',
        },
        '.news-link': {
          paddingLeft: '2rem',
          maxWidth: 'calc(100% - 120px)',
          flexBasis: 'calc(100% - 120px)',
          '@media (min-width: 1024px)': {
            maxWidth: '100%',
            flexBasis: '100%',
            padding: 0,
          }
        },
      }
    }
  },
  '.publication-list': {
    margin: '4rem auto 0 auto',
    maxWidth: '1200px',
    '.filter': {
      justifyContent: 'flex-start',
    },
    '.news': {
      '&-picture' : {
        height: 240,
        maxWidth: '100%',
        flexBasis: '100%',
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(1/3 * 100% - 40px)',
          flexBasis: 'calc(1/3 * 100% - 40px)',
        },
      },
      '&-info': {
        position: 'relative',
        maxWidth: '100%',
        flexBasis: '100%',
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(2/3 * 100% - 40px)',
          flexBasis: 'calc(2/3 * 100% - 40px)',
        },
      },
      '&-button': {
        width: '100%',
        alignSelf: 'flex-end',
        justifyContent: 'flex-end',
        display: 'flex',
        '@media (min-width: 1024px)': {
          width: 80,
          justifyContent: 'flex-start',
          display: 'block',
        }
      },
      '&-link': {
        position: 'absolute',
        bottom: -36,
        left: '2rem',
        '@media (min-width: 1024px)': {
          bottom: '2rem',
        }
      }
    }
  }
}) 

const defaultNews = {
  '&-date': {
    color: Colors.mediumGrey
  },
  '&-title': {
    textTransform: 'uppercase',
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'black',
  },
  '&-info': {
    padding: '2rem',
  },
  '&-link': {
    ...Link,
    color: Colors.mediumGrey
  },
}

export const NewsCardStyle = (picture) => css({
  width: '100%',
  background: 'white',
  boxShadow: `0 0 20px 0 ${Colors.shadow}`,
  margin: '2rem 0',
  '.news': {
    ...defaultNews,
    '&-picture': {
      position: 'relative',
      overflow: 'hidden',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `#000 url(${picture}) no-repeat center`,
        backgroundSize: 'auto 100%',
        transition: `transform 1000ms ${Easings.customEase}`,
      }
    },
  },
  '&:hover': {
    '.news-picture:after': {
      transform: 'scale(1.2)',
    }
  }
})

export const ArticleStyle = css({
  position: 'relative',
  zIndex: 2,
  '@media (min-width: 1024px)': {
    '.btn-pdf':{
      borderTop: '1px solid white',
    },
  },
  '.news': {
    maxWidth: '100%',
    flexBasis: '100%',
    order: -1,
    '@media (min-width: 1024px)': {
      maxWidth: 'calc(100% - 80px)',
      flexBasis: 'calc(100% - 80px)',
      order: 1,
    },
    '&-inner': {
      maxWidth: '100%',
      margin: '4rem 1rem',
      textAlign: 'center',
      '@media (min-width: 1024px)': {
        margin: '4rem auto',
        width: 'calc(9/11 * 100%)',
        maxWidth: 960,
      } 
    },
    ...defaultNews,
    '&-content': {
      maxWidth: 680,
      margin: '2rem auto',
      'p': {
        textAlign: 'left'
        // textAlign: 'justify',
        // textAlignLast: 'center',
      },
    },
    '&-cover': {
      margin: '4rem auto',
    },
    '&-picture': {
      height: 600,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    },
    '&-legend': {
      textAlign: 'left',
      margin: '1rem 0',
      fontSize: '0.8125rem',
    },
    '&__nav': {
      marginTop: '2rem',
      display: 'none',
      '@media (min-width: 1024px)': {
        display: 'flex',
      },
      '&-item': {
        width: '50%',
        textTransform: 'uppercase',
        '&--full': {
          width: '100%',
        },
        'a': {
          color: Colors.grey,
          fontWeight: 'bold',
          fontSize: '0.8125rem',
        },
      },
      '.btn--arrow':{
        background: Colors.extraLightGrey,
        width: 80,
        height: 80,
        lineHeight: '80px',
        display: 'inline-block',
        textAlign: 'center',
        'svg': {
          fill: Colors.grey,
          verticalAlign: 'middle',
        }
      }
    },

    '&__previous': {
      textAlign: 'left',
      '.btn--arrow': {
        marginRight: '1rem',
      },
      'svg': {
        transform: 'scale(-1)',
      }      
    },
    '&__next': {
      textAlign: 'right',  
      '.btn--arrow': {
        marginLeft: '1rem',
      },  
    },
  },
  '.news-title': {
    position: 'relative',
    '&:after': {
      content: "''",
      display: "block",
      width: 50,
      height: 4,
      background: 'black',
      margin: '1rem auto',
    }
  },
  
})


// WEBPACK FOOTER //
// ./src/styles/containers/article.js